import Cropper from 'react-easy-crop';
import { useState, useCallback, useEffect, useRef } from 'react';
import { Area } from 'react-easy-crop';

type Props = {
  imageSrc: any;
  zoom: number;
  crop: { x: number; y: number };
  position: number;
  onZoomChange: (z: number) => void;
  onCropChange: (crop: { x: number; y: number }) => void;
  onCropComplete: (croppedArea: Area, croppedPixels: Area) => void;
  aspect: any;
};

function DraggableImage({
  imageSrc,
  zoom,
  crop,
  position,
  onZoomChange,
  onCropChange,
  onCropComplete,
  aspect,
}: Props) {
  // const [zoom, setZoom] = useState(1);
  // const [position, setPosition] = useState({ x: 0, y: 0 });
  // const onCropChange = useCallback((crop: any) => {
  //   setPosition(crop);
  // }, []);

  // const onZoomChange = useCallback((z: number) => {
  //   setZoom(z);
  // }, []);
  const [imageStyle, setImageStyle] = useState<React.CSSProperties>({});
  const getImageRatio = (url: string): Promise<number> => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const ratio = img.naturalWidth / img.naturalHeight;
        resolve(ratio);
      };

      img.onerror = reject;
      img.src = url;
    });
  };

  useEffect(() => {
    const loadImageRatio = async () => {
      try {
        const img = new Image();
        img.src = imageSrc;
        img.onload = () => {
          const ratio = img.naturalWidth / img.naturalHeight;
          const fixedHeight = 490;
          const width = fixedHeight * ratio;

          setImageStyle({
            height: fixedHeight,
            width,
          });
        };
      } catch (error) {
        console.error('Không thể load ảnh:', error);
      }
    };

    if (imageSrc) loadImageRatio();
  }, [imageSrc]);
  return (
    <div className="w-full h-full relative group" style={{ position: 'relative' }}>
      <Cropper
        // onCropComplete={onCropComplete}
        // image={imageSrc}
        // crop={crop}
        // zoom={zoom}
        // aspect={490 / 394} // Tỉ lệ cover Facebook (1200x600) là 2:1
        // cropShape="rect"
        // showGrid={false}
        // restrictPosition={false}
        // onCropChange={onCropChange}
        // onZoomChange={onZoomChange}
        style={{
          containerStyle: { width: '100%', height: '100%' },
        }}
        image={imageSrc}
        crop={crop}
        zoom={zoom}
        aspect={aspect}
        onCropChange={onCropChange}
        onCropComplete={onCropComplete}
        onZoomChange={onZoomChange}
      />

      {/* Khi hover thì hiện thanh zoom */}
      <input
        type="range"
        min={1}
        max={3}
        step={0.1}
        value={zoom}
        onChange={(e) => onZoomChange(Number(e.target.value))}
        className="absolute bottom-2 left-1/2 -translate-x-1/2 w-[60%] hidden group-hover:block z-50"
      />
    </div>
  );
}
export default DraggableImage;
